import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import Login from "./components/login/Login";
import { IS_TEST_MODE } from "./awsConfig";
import { BrowserRouter } from "react-router-dom";

import "./awsConfig";
import "./index.css";
import Footer from "./components/footer/Footer";
import AppAdmin from "./components/v2/components/AppAdmin";
import Header from "./components/header/Header";
import { Box } from "@mui/material";

function App() {
  const [authenticated, setAuthenticated] = useState(IS_TEST_MODE);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return authenticated ? (
      <BrowserRouter>
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", overflow: 'hidden', width: '100vw' }}>
          <Header
              open={sidebarOpen}
              onToggle={() => setSidebarOpen(p => !p)}
          />
          <Box sx={{ flex: 1, overflow: "auto", mt: "64px" }}>
            <AppAdmin />
          </Box>
        </Box>
      </BrowserRouter>
  ) : (
      <>
        <Login onLoginSuccess={() => setAuthenticated(true)} />
        <Footer />
      </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

reportWebVitals();